import { render, staticRenderFns } from "./SectorSpecialists.vue?vue&type=template&id=669fe57e"
import script from "./SectorSpecialists.vue?vue&type=script&lang=js"
export * from "./SectorSpecialists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('669fe57e')) {
      api.createRecord('669fe57e', component.options)
    } else {
      api.reload('669fe57e', component.options)
    }
    module.hot.accept("./SectorSpecialists.vue?vue&type=template&id=669fe57e", function () {
      api.rerender('669fe57e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Sector/SectorSpecialists.vue"
export default component.exports